import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "BankOfXY",
  "use": "BankOfXY-usage",
  "viewBox": "0 0 68 68",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 68 68\" id=\"BankOfXY\">\r\n<defs>\r\n    <style>\r\n      #BankOfXY .cls-1 {\r\n        fill: #004098;\r\n        fill-rule: evenodd;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"BankOfXY_兴业logo\" class=\"cls-1\" d=\"M1910.33,751.937s-16.75-4.858-32.78,7.954c0,0-12.99,11.566.79,23.661,0,0,12.22,11.737,37.74,7.545,0,0,21.44-2.278,23.72-17.723,0,0,3.47-13.413-18.33-16.407,0,0-22.53-4.071-34.75,12.335,0,0,14.86,8.263,20.01,11.017l16.65-9.221-7.3-3.713-9.11,4.671-7.43-4.072a22.449,22.449,0,0,1,18.33-4.554s19.41,0.718,12.46,13.772c0,0-6.71,10.538-34.74,6.825,0,0-26.36-5.508-10.78-23.471,0,0,6.22-7.424,25.52-8.622v0Zm0,0\" transform=\"translate(-1872.015 -737.515)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/BankOfXY.svg
// module id = 9eGH
// module chunks = 37